import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import homeImage from 'assets/images/homepage/homepageimage.png';

import { MODALS } from 'global-constants';

import WithPush from 'shared/HOCs/WithPush';

import Image from 'shared/components/Image';
import Button from 'shared/components/Button';

import { openModal } from 'shared/components/Modals/reducer';

import styles from './styles.module.scss';

class Headline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ''
    };
  }

  updateEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  openSignUp = () => {
    this.props.openModal({
      modalName: MODALS.SIGNUP,
      data: { email: this.state.email }
    });
  };

  render() {
    return (
      <div className={styles.homeHeadlineContainer}>
        <div className={styles.content}>
          <div className={styles.signupForm}>
            <div className={styles.title}>
              <h1>PropTech Procurement Experts</h1>
            </div>
            <div className={styles.description}>
              Unissu scours the world to bring you qualified PropTech sales
              leads.<br />With c.3000 leads expected in 2024, you can’t afford
              to miss out on our unrivalled market intelligence and revenue
              opportunities.
            </div>
            <div className={styles.headlinetagline}>
              Stop searching. Start selling.
            </div>
            <a href="/proptech-procurement/open/">
              <Button color="orange-gradient" className={styles.ProptecCTA}>
                {' '}
                View Live Leads{' '}
              </Button>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  openModal
};

export default WithPush(
  connect(
    null,
    mapDispatchToProps
  )(Headline)
);
